<div class="dialog-content-min">
  <form [formGroup]="locationTypeForm">
    <div class="formgrid grid m-2">
      <div class="field col-12">
        <label for="locationtypename" class="required-label">{{labelName}}<span class="maxchars">(Max 200 chars)</span><span>*</span></label>
        <textarea class="form-control" placeholder="Enter {{labelName}} Name" id="name"
          formControlName="locationtypename" name="locationtypename" pInputTextarea></textarea>
             <span style="color:red"
        *ngIf="locationTypeForm.get('locationtypename').invalid && (locationTypeForm.get('locationtypename').dirty || locationTypeForm.get('locationtypename').touched)">
        {{getErrorMessage(locationTypeForm ,validation_message,'locationtypename')}}
      </span>
        <!-- <span class="errormessage"
          *ngIf="locationTypeForm.get('locationtypename').invalid && (locationTypeForm.get('locationtypename').dirty || locationTypeForm.get('locationtypename').touched)">
          {{getErrorMessage(locationTypeForm ,validation_message,'locationtypename')}}
        </span> -->
      </div> 
    </div>


    <div class="formgrid grid m-2" *ngIf="isEdit">
      <div class="field col-12">
        <label for="activeflag"> Active Flag </label>
        <p-dropdown [options]="activeFlag" id="activeflag" [filter]="true" appendTo="body" name="activeflag"
          optionLabel="labelname" optionValue="value" placeholder="Select Flag" [resetFilterOnHide]="true"
          formControlName="activeflag"></p-dropdown>
        <span class="errormessage"
          *ngIf="locationTypeForm.get('activeflag').invalid && locationTypeForm.get('activeflag').touched ">
          {{getErrorMessage(locationTypeForm ,validation_message,'activeflag')}}
        </span>
      </div>
    </div>
  </form>
</div>

<div class="custom-dialog-footer">
  <div class="mt-1"></div>
  <p-button class="m-1" label="Close" styleClass="customeclose"
    (click)="closemodal(locationTypeForm,this.ref,'Are you sure you want to close?')"></p-button>
  <p-button class="m-1" *ngIf="!onlyView" label="{{saveTitle}}" styleClass="customesave"
    (click)="addLocationType()"></p-button>
  <div class="mt-1"></div>
</div>